import React from 'react';
import Lottie from 'react-lottie';
import i18next from 'i18next';

import { getLottieOptions } from '~utils/lottie';
import uniqueLoading from '~assets/lotties/unique-loading.json';
import CreditEndingStatus from '~app/components/CreditEndingStatus';
import SimulationLoadingWrapper from '~app/components/SimulationLoadingWrapper';
import { useRedirect } from '~app/hooks/useRedirect';
import { ROUTES } from '~constants/routes';

import styles from './styles.module.scss';

export default function EvaluationPending() {
  const handleRedirect = useRedirect();
  const handleContinue = handleRedirect({ customStepName: ROUTES.CLIENT_FLOW_CHOICE.stepName });
  const evaluationAnim = () => (
    <div className={styles.salesContainer}>
      <Lottie
        options={getLottieOptions({
          loop: true,
          autoplay: true,
          animationData: uniqueLoading
        })}
      />
    </div>
  );
  return (
    <SimulationLoadingWrapper>
      <CreditEndingStatus
        title={i18next.t('EvaluationPending:title')}
        info={i18next.t('EvaluationPending:info')}
        summaryButton={i18next.t('EvaluationPending:summaryButton')}
        Image={evaluationAnim}
        handleCheckout={handleContinue}
      />
    </SimulationLoadingWrapper>
  );
}
